import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import translate from 'components/hoc/translate';
import { Field, getFormValues, reduxForm } from 'redux-form';
import { getRuleConfig } from 'helpers/rulesHelper';
import utils from 'helpers/utils';
import RenderAutoCompleteDataInputField from 'components/form/InputFields/AutoCompleteField/RenderAutoCompleteDataInputField';
import styled from 'styled-components';
import validations from 'helpers/forms/validations';
import { isEmpty } from 'lodash';

const StyledInputWrapper = styled.div`
    display: flex;
    flex-direction: column;
`;

class MembershipRule extends React.Component {
    componentDidUpdate(prevProps) {
        const {
            formValues,
            onUpdate,
        } = this.props;

        if (!isEmpty(utils.diffObjects(prevProps.formValues, formValues))) {
            onUpdate(formValues);
        }
    }

    render() {
        const {
            translate,
        } = this.props;

        return (
            <StyledInputWrapper>
                <Field
                    component={ RenderAutoCompleteDataInputField }
                    name='value'
                    label={ translate('resources.products.fields.value') }
                    optionValue='id'
                    reference='memberships'
                    searchBy='name'
                    searchParams={ {
                        size: 12,
                        sort_by: 'name',
                        sort_direction: 'asc',
                    } }
                />
            </StyledInputWrapper>
        );
    }
}

MembershipRule.propTypes = {
    formValues: PropTypes.shape({
        value: PropTypes.oneOfType([
            PropTypes.number,
            PropTypes.string,
        ]),
    }),
    onUpdate: PropTypes.func,
    translate: PropTypes.func.isRequired,
};

const mapStateToProps = (state, props) => {
    const {
        id,
        type,
        value,
    } = props;

    const form = `${ type }-${ id }`;

    const config = getRuleConfig(utils.firstCharToLowerCase(type)).config;

    return {
        form,
        formValues: getFormValues(form)(state),
        initialValues: {
            ...config,
            ...value,
        },
    };
};

const enhance = compose(
    translate,
    connect(mapStateToProps),
    reduxForm({
        validate: (values, props) => {
            const errors = {};

            utils.each(values, (value, key) => {
                if (validations.required(value, values, props)) {
                    errors[key] = validations.required(value, values, props);
                }
            });

            return errors;
        },
    }),
);

export default enhance(MembershipRule);


// WEBPACK FOOTER //
// ./src/pages/discounts/rules/types/MembershipRule.js